import { Injectable } from '@angular/core';
import { ModelHelper } from '@dentsply-sirona/utilities';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SortDirection } from '../enums/sort-direction.enum';
import { Dongle } from '../models/dongle.model';
import { WhereFilter } from '../models/where-filter.model';
import { DongleSchema } from '../schemas/dongle.schema';
import { GraphqlService } from './graphql.service';

/**
 * Dongle service
 */
@Injectable({
	providedIn: 'root'
})
export class DongleService extends GraphqlService {
	/**
	 * Get dongle list
	 */
	getDongleList(
		filters: WhereFilter[] = [],
		pageIndex: number = 0,
		resultsPerPage: number = 10,
		orderBy?: string,
		sortDirection?: string
	): Observable<{ totalCount: number; list: Dongle[] }> {
		let isAscending = null;
		if (sortDirection === SortDirection.ASCENDING) {
			isAscending = 'true';
		} else if (sortDirection === SortDirection.DESCENDING) {
			isAscending = 'false';
		}
		return this.query(DongleSchema.getDongleList, {
			filters,
			pageIndex,
			resultsPerPage,
			orderBy,
			isAscending
		}).pipe(
			map((data: any) => ({
				totalCount: data.donglelist.totalCount,
				list: ModelHelper.mapArray<Dongle>(Dongle, data.donglelist.list)
			}))
		);
	}

	/**
	 * Remove dongle
	 */
	removeDongle(dongleId: String) {
		return this.mutation(DongleSchema.removeDongle, {
			dongleId
		}).pipe(map((response: any) => ModelHelper.mapArray<Dongle>(Dongle, response.removeDongle)));
	}
}
